import omit from "lodash/omit";
export default (user) => omit(user, "Avatar");
